<template>
  <pagebreadcrumb :title="title" :text="text" :text1="text1" />
  <!-- Page Content -->
  <div class="content">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-lg-4 col-xl-3 theiaStickySidebar">
          <div class="stickysidebar">
            <projectsearch></projectsearch>
          </div>
        </div>
        <!-- /Search Filter -->
        <div class="col-md-12 col-lg-8 col-xl-9">
          <div class="sort-tab develop-list-select">
            <div class="row align-items-center">
              <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                <div class="d-flex align-items-center">
                  <div class="freelance-view">
                    <h4>Found 9 Results</h4>
                  </div>
                </div>
              </div>
              <div
                class="col-xl-6 col-lg-6 col-md-6 col-sm-6 d-flex justify-content-sm-end"
              >
                <div class="sort-by">
                  <vue-select :options="Rating" id="rating" placeholder="Select" />
                </div>
                <ul class="list-grid d-flex align-items-center">
                  <li>
                    <router-link to="/freelancer/project"
                      ><i class="fas fa-th-large"></i
                    ></router-link>
                  </li>
                  <li>
                    <router-link to="/freelancer/project-list" class="favour-active"
                      ><i class="fas fa-list"></i
                    ></router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="list-book-mark book-mark favour-book">
            <div class="row">
              <div class="col-lg-12">
                <div
                  class="project-list-card"
                  v-for="record in Project_List"
                  :key="record.id"
                >
                  <a href="javascript:void(0);" class="add-fav-list"
                    ><i class="fa-regular fa-heart"></i
                  ></a>
                  <div class="company-detail-image">
                    <img
                      :src="require(`@/assets/img/${record.Image}`)"
                      class="img-fluid"
                      alt="logo"
                    />
                  </div>
                  <div>
                    <div class="company-title">
                      <p>{{ record.Ui }}</p>
                      <h4>
                        {{ record.Designer }}
                      </h4>
                    </div>
                    <div class="company-splits">
                      <div>
                        <div class="company-address">
                          <ul>
                            <li><i class="feather-map-pin"></i>{{ record.Map }}</li>
                            <li><i class="feather-calendar"></i>{{ record.Calendar }}</li>
                            <li><i class="feather-file-2"></i>{{ record.File }}</li>
                          </ul>
                        </div>
                        <div class="company-description">
                          <p>
                            {{ record.Description }}
                          </p>
                        </div>
                        <div class="company-description">
                          <div class="tags">
                            <a href="javascript:void(0);"
                              ><span class="badge badge-pill badge-design me-1">{{
                                record.After
                              }}</span></a
                            >
                            <a href="javascript:void(0);"
                              ><span class="badge badge-pill badge-design me-1">{{
                                record.Illustrator
                              }}</span></a
                            >
                            <a href="javascript:void(0);"
                              ><span class="badge badge-pill badge-design me-1">{{
                                record.Html
                              }}</span></a
                            >
                            <a href="javascript:void(0);"
                              ><span class="badge badge-pill badge-design me-1">{{
                                record.Whiteboard
                              }}</span></a
                            >
                          </div>
                        </div>
                      </div>
                      <div class="company-split-price">
                        <h5>{{ record.Cost }}</h5>
                        <h6>{{ record.Price }}</h6>
                        <router-link to="/freelancer/project-details" class="btn btn-submits"
                          >Submit Proposal</router-link
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ul class="paginations list-pagination">
                  <li class="page-item">
                    <a href="javascript:void(0);"><i class="feather-chevron-left"></i></a>
                  </li>
                  <li class="page-item">
                    <a href="javascript:void(0);" class="active">1</a>
                  </li>
                  <li class="page-item"><a href="javascript:void(0);">2</a></li>
                  <li class="page-item"><a href="javascript:void(0);">3</a></li>
                  <li class="page-item"><a href="javascript:void(0);">...</a></li>
                  <li class="page-item"><a href="javascript:void(0);">10</a></li>
                  <li class="page-item">
                    <a href="javascript:void(0);"
                      ><i class="feather-chevron-right"></i
                    ></a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Content -->
  <projectlist></projectlist>
</template>
<script>
import Project_List from "@/assets/json/project-list.json";
export default {
  data() {
    return {
      Project_List: Project_List,
      title: "Project List",
      text: "Home",
      text1: "Projects",
      Rating: ["Relevance", "Rating", "Popular", "Latest", "Free"],
    };
  },
};
</script>
